// Function loadChatbotButton loads the ChatbotButton class by dynamically importing the js on demand if needed

export function loadChatbotButton($parentEl, isList = false) {

	return import(/* webpackChunkName: "wg-chatbot-button-chunk" */ '../widgets/chatbotButton').then(wg => {

		const { ChatbotButton } = wg;

		let $wg = $parentEl.querySelector('[data-wg="ChatbotButton"]');

		if(!$wg) {
			// console.info('ChatbotButton: no widget found');
			return null;
		}

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="ChatbotButton"]');
			let instances = [];
			$wgCol.forEach(($wg, i) => {
				instances.push( new ChatbotButton($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new ChatbotButton($wg);
		}


	}).catch(error => error+'An error occurred while loading the ChatbotButton widget');

}
